var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGreenLine = function SvgGreenLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500 250H0",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 40,
    stroke: "#26890c",
    fill: "transparent",
    "data-name": "Path 280374"
  })));
};
export default SvgGreenLine;